// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.need-help-module__need-help___XoB2o {
  color: var(--primary600, #4b286d);
  cursor: pointer;
  font-weight: 600;
}
.need-help-module__need-help___XoB2o:focus {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}
.need-help-module__need-help___XoB2o:hover {
  color: var(--primary600, #4b286d);
}`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/react-components/modal-templates/templates/codes-modal/components/need-help/need-help.module.scss","data:;charset=utf-8,@use%20'../functions/color'%20as%20*;%0A%0A@mixin%20focus-outline($color:%20color(focus),%20$applyDirectly:%20false)%20%7B%0A%20%20@if%20$applyDirectly%20%7B%0A%20%20%20%20outline:%20$color%20solid%202px;%0A%20%20%20%20outline-offset:%203px;%0A%20%20%7D%20@else%20%7B%0A%20%20%20%20&:focus%20%7B%0A%20%20%20%20%20%20outline:%20$color%20solid%202px;%0A%20%20%20%20%20%20outline-offset:%203px;%0A%20%20%20%20%7D%0A%20%20%7D%0A%7D%0A"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;AAMF;ACJI;EACE,wCAAA;EACA,mBAAA;ADMN;AAPE;EACE,iCAAA;AASJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"need-help": `need-help-module__need-help___XoB2o`
};
export default ___CSS_LOADER_EXPORT___;
